import axios from "_u/axios"

// 收支流水列表
export const financesFlowList = body => {
    return axios.post("api/finance/flow/list", body)
}

// 收支统计(收入/支出图表)
export const financeStatistic = body => {
    return axios.post("api/finance/flow/flowStatistic", body)
}

// 收支统计(收入/支出统计表左侧列表)
export const financesFlowSumList = body => {
    return axios.post("api/finance/flow/flowSumList", body)
}

// 收支统计(收入/支出统计表右侧明细列表)
export const financeFlowDetailList = body => {
    return axios.post("api/finance/flow/flowDetailList", body)
}

// 累计收支统计
export const totalFeeStatistic = body => {
    return axios.post("api/ems/stats/totalFeeStatistic", body)
}